import animateSwitcher from '../../scripts/animateSwitcher'
import { scrollToElem } from '../../utils';

export default {
	data() {
		return {
			qaFormShowed: false
		}
	},
    // watch: {
    //     qaFormShowed() {
    //     }
    // },
    methods: {
        showQaForm() {
            this.qaFormShowed = true;
            this.$nextTick(() => {
                scrollToElem('form');
            })

            animateSwitcher();
        }
    }
}
